import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import {Link, withRouter} from "react-router-dom";
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import Button from "@material-ui/core/Button/Button";
import Hidden from "@material-ui/core/Hidden/Hidden";
import {truncate} from "../../../config/values";
import {defaultVariabls} from "../../../config";
import {Translate} from "../../../config/Translate";
import HighLighterButton from "./components/HighLighterButton";
import FontSizeButton from "./components/FontSizeButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Brightness4RoundedIcon from "@material-ui/icons/Brightness4Rounded";
import SearchButton from "./components/SearchButton";
import TocListButton from "./components/TocListButton";
import {ArrowBackRounded, ChevronLeftRounded, ChevronRightRounded, SyncRounded} from "@material-ui/icons";
import {ReactReader} from "react-reader";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import BooNameButton from "./components/BooNameButton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import GoToPageButton from "./components/GoToPageButton";
class PDFBookReader extends React.Component {
    state = {
        numPages:null,
        pageNumber:!!this.props.book.location ? parseInt(this.props.book.location) : 1,
        scale: this.props.width === "xs" ? .75 : this.props.width === "sm" ? .75 : 1,
    }
    componentDidMount() {
        document.body.classList.add('no-chat');

    }
    componentWillUnmount(){
        document.body.classList.remove('no-chat');
    }
    onDocumentLoadSuccess({ numPages }) {
        this.setState({
            numPages
        })
    }
    async handlePage(page){
        await this.setState({
            pageNumber:parseInt(page)
        })
        await this.syncBook()
    }
    syncBook(){
        let {pageNumber} = this.state;
        this.setState({
            syncing:true
        })
        let {book} = this.props;
        let data = new FormData();
        data.append('location', pageNumber);
        data.append('book_id',  book.id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/ebook/sync`, data, config)
            .then(response => {
                this.setState({
                    syncing:false
                })
            })
            .catch(error => {
                this.props.history.push("/library")
                this.props.enqueueSnackbar(Translate.bookUsageExpired, {
                    variant: 'error',
                });
                this.setState({
                    syncing:false
                })
                return false
            });
    }
    render(){
        let {pageNumber,numPages,syncing,scale} = this.state;
        let {url,title} = this.props;
        return (
            <>
                <div className="reader-header">
                    <Hidden smDown>
                        <Tooltip title={title}>
                            <h1>{truncate(title,25)}</h1>
                        </Tooltip>
                    </Hidden>

                    <a target="_blank" href={defaultVariabls.website}>
                        <img
                            className={"logo"}
                            src={`${defaultVariabls.website}/images/epanjere/panjere-logo.png`}
                            alt={Translate.appName}
                        />
                    </a>
                    <div className="actions">
                        <Hidden smUp>
                            <BooNameButton title={title}/>
                        </Hidden>
                        <GoToPageButton
                            pageNumber={pageNumber}
                            numPages={numPages}
                            handlePage={(page) => this.handlePage(page)}
                        />
                        <Tooltip arrow title={Translate.zoomIn}>
                            <IconButton
                                size="small"
                                onClick={() => this.setState({
                                    scale: scale + .25
                                })}
                                disabled={scale === 6}
                            >
                                <ZoomInIcon/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow title={Translate.zoomOut}>
                            <IconButton
                                size="small"
                                onClick={() => this.setState({
                                    scale: scale - .25
                                })}
                                disabled={scale === .25}
                            >
                                <ZoomOutIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow title={Translate.backToLibrary}>
                            <IconButton
                                size="small"
                                component={Link}
                                to={'/library'}
                            >
                                <ArrowBackRounded/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
                <div className="react-reader-container">
                    <Document
                        file={url}
                        onLoadSuccess={this.onDocumentLoadSuccess.bind(this)}
                        loading={<AppCardLoaderFields/>}
                    >
                        <Page
                            pageNumber={pageNumber}
                            scale={scale}
                        />
                    </Document>
                    <IconButton
                        className="prev-btn pdf-btn"
                        onClick={() => this.setState({
                            pageNumber: pageNumber - 1
                        })}
                        color="primary"
                        disabled={pageNumber === 1}
                    >
                        <ChevronRightRounded  fontSize="large"/>
                    </IconButton>
                    <IconButton
                        className="next-btn  pdf-btn"
                        onClick={() => this.setState({
                            pageNumber: pageNumber + 1
                        })}
                        color="primary"
                        disabled={pageNumber === numPages}
                    >
                        <ChevronLeftRounded fontSize="large"/>
                    </IconButton>

                </div>
                <div className="reader-footer">
                    <Typography>
                        {pageNumber} / {numPages}
                    </Typography>
                    <Button
                        onClick={() => this.syncBook()}
                        size="small"
                        startIcon={syncing ? <CircularProgress color="secondary" size={16}/> : <SyncRounded/>}
                    >
                        {Translate.sync}
                    </Button>
                </div>
            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(withWidth()(PDFBookReader)))));

